import axios from "axios";
import Vue from "vue";
import router from "../router/index";
let api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + "/" + process.env.VUE_APP_API_VERSION,
  timeout: 60000
});

// api.interceptors.request.use(
//   config => {
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );
// api.interceptors.response.use(
//   response => {
//     if (response.status === 200 || response.status === 201) {
//       return Promise.resolve(response);
//     } else {
//       return Promise.reject(response);
//     }
//   },
//   error => {
//     return error;
//   }
// );

export default api;
